import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getAssetPropsCounts } from '#/graphql/queries';
import type { GetAssetPropsCountsQuery } from '#/graphql/types';

export const GET_ASSET_PROPS_COUNTS = gql(getAssetPropsCounts);

const useAssetPropsCounts = () => {
  const { data, loading }: QueryResult<GetAssetPropsCountsQuery> = useQuery(
    GET_ASSET_PROPS_COUNTS,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const { assets, types, manufacturers, models, locations } = data?.getAssetPropsCounts?.data ?? {};

  return { assets, types, manufacturers, models, locations, loading };
};

export default useAssetPropsCounts;
